import { render, staticRenderFns } from "./smart-video.vue?vue&type=template&id=50ef85aa&scoped=true"
import script from "./smart-video.vue?vue&type=script&lang=js"
export * from "./smart-video.vue?vue&type=script&lang=js"
import style0 from "./smart-video.vue?vue&type=style&index=0&id=50ef85aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ef85aa",
  null
  
)

export default component.exports